import { forwardRef } from 'react'
import { TextField } from '@mui/material'

const TextFieldPhoneInput = (props: any, ref: any) => {
  return <TextField {...props} fullWidth variant="outlined" />
}
export default forwardRef(TextFieldPhoneInput)
